var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlastic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7083",
    "data-name": "Rectangle 7083",
    width: 380,
    height: 160,
    transform: "translate(726 227)",
    fill: "#f0e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 124.03,
    height: 77.492,
    rx: 4,
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    width: 124.03,
    height: 77.492,
    rx: 4,
    fill: "#dceaef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6838",
    "data-name": "Rectangle 6838",
    width: 132.785,
    height: 85.183,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6837",
    "data-name": "Rectangle 6837",
    width: 132.785,
    height: 85.183,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Terms_Conditions",
    "data-name": "Terms & Conditions",
    transform: "translate(-726 -227)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28199",
    "data-name": "Group 28199",
    transform: "translate(6.238)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28184",
    "data-name": "Group 28184",
    transform: "translate(855.229 347.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M0,22.547l12.719-7.723V0L0,7.751Z",
    transform: "translate(12.719 7.516)",
    fill: "#fcea80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M12.719,22.547,0,14.824V0L12.719,7.751Z",
    transform: "translate(0 7.482)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M0,7.6,12.719,0,25.438,7.6,12.719,15.32Z",
    transform: "translate(0 0)",
    fill: "#fefefe"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28185",
    "data-name": "Group 28185",
    transform: "translate(774.806 264.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31465",
    "data-name": "Path 31465",
    d: "M14.24,135.679.1,121.9l14.14,8.656Z",
    transform: "translate(-0.089 -108.155)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31466",
    "data-name": "Path 31466",
    d: "M125,135.653l14.1-13.787L125,130.517Z",
    transform: "translate(-110.905 -108.129)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31467",
    "data-name": "Path 31467",
    d: "M14.095,0,0,13.756l14.095,8.637Z",
    transform: "translate(0 0)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31468",
    "data-name": "Path 31468",
    d: "M125,0l14.095,13.756L125,22.393Z",
    transform: "translate(-110.905 0)",
    fill: "#fefefe"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28186",
    "data-name": "Group 28186",
    transform: "translate(1019.281 249.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7-2",
    "data-name": "Fill 7",
    d: "M0,22.547l12.719-7.723V0L0,7.751Z",
    transform: "translate(12.719 7.516)",
    fill: "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8-2",
    "data-name": "Fill 8",
    d: "M12.719,22.547,0,14.824V0L12.719,7.751Z",
    transform: "translate(0 7.482)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9-2",
    "data-name": "Fill 9",
    d: "M0,7.6,12.719,0,25.438,7.6,12.719,15.32Z",
    transform: "translate(0 0)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28198",
    "data-name": "Group 28198",
    transform: "translate(832.266 231.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28197",
    "data-name": "Group 28197",
    transform: "translate(-4.529 -1.135)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6373",
    "data-name": "Mask Group 6373",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 74.928, 17.727)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28190",
    "data-name": "Group 28190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31469",
    "data-name": "Path 31469",
    d: "M0,0h124.03V77.493H0Z",
    transform: "translate(0 0)",
    fill: "#f8f8f8"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6374",
    "data-name": "Mask Group 6374",
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 56.085, 9.139)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28194",
    "data-name": "Group 28194",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31485",
    "data-name": "Path 31485",
    d: "M0,0H124.031V77.493H0Z",
    transform: "translate(0 0)",
    fill: "#dceaef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28233",
    "data-name": "Group 28233",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 23.904, 1.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26930",
    "data-name": "Group 26930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26929",
    "data-name": "Group 26929",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5982",
    "data-name": "Group 5982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5981",
    "data-name": "Group 5981"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18333",
    "data-name": "Path 18333",
    d: "M0,0H132.786V85.183H0Z",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5977",
    "data-name": "Group 5977",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26928",
    "data-name": "Group 26928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26927",
    "data-name": "Group 26927",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5976",
    "data-name": "Group 5976",
    transform: "translate(-9.356 -54.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5975",
    "data-name": "Group 5975",
    transform: "translate(0 0)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18334",
    "data-name": "Path 18334",
    d: "M51.212,178.45,0,89.226,51.212,0l51.214,89.226Z",
    transform: "translate(69.605)",
    fill: "#0b1622"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1245",
    "data-name": "Ellipse 1245",
    cx: 53.89,
    cy: 54.905,
    rx: 53.89,
    ry: 54.905,
    transform: "translate(0 78.768)",
    fill: "#fa9419",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18335",
    "data-name": "Path 18335",
    d: "M35.442,68.47a55.777,55.777,0,0,0,2.732-17.3A54.912,54.912,0,0,0,3.858,0L0,6.722Z",
    transform: "translate(69.603 82.503)",
    fill: "#fff"
  }))))))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24041",
    "data-name": "Path 24041",
    d: "M21.716.133,2.58,0A2.545,2.545,0,0,0,.086,2.591L0,14.751a2.545,2.545,0,0,0,2.458,2.626l19.136.134a2.545,2.545,0,0,0,2.494-2.592l.085-12.16A2.546,2.546,0,0,0,21.716.133Z",
    transform: "translate(9.465 30.025)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlastic);
export default __webpack_public_path__ + "static/media/plastic.3889bffc095427bb2379f0293c648da4.svg";
export { ForwardRef as ReactComponent };